import { QueryStep } from '@/types';
import TableRef from '@/util/TableRef';
import LayerBuilder from '@/components/layers/LayerBuilder';
import { buildCollapsedLayerId, buildUsedAliases } from '@/reducers/layers';
import { useLoadSteps } from '..';

export const useLoadSteps_LEGACY = (skip = false) => {
  const { data, ...rest } = useLoadSteps(skip);

  let state: {
    all: QueryStep[];
    usedAliases: Record<string, TableRef>;
    collapsedLayerId: Maybe<number>;
    selectedLayerId: Maybe<number>;
  } = {
    all: [],
    usedAliases: {},
    collapsedLayerId: null,
    selectedLayerId: null,
  };

  if (data) {
    const { activeSteps, inactiveSteps } = data.reduce(
      (grouped: any, step: any) => {
        if (step._active) {
          grouped.activeSteps.push(LayerBuilder.build(step));
        } else {
          grouped.inactiveSteps.push(LayerBuilder.build(step));
        }
        return grouped;
      },
      {
        activeSteps: [],
        inactiveSteps: [],
      },
    );
    const steps = [...activeSteps, ...inactiveSteps];
    const usedAliases = buildUsedAliases(steps) as Record<string, TableRef>;
    const collapsedLayerId = buildCollapsedLayerId(activeSteps);
    const selectedLayerId = activeSteps[activeSteps.length - 1]?.id();

    state = {
      all: steps,
      usedAliases,
      collapsedLayerId,
      selectedLayerId,
    };
  }

  return { ...state, ...rest } as const;
};
